// =============================================================================
// world座標 → 画面座標 投影（DOMマーカー用）。捕捉カメラの行列を読むだけ。
// =============================================================================

export interface Projected {
  x: number;
  y: number;
  depth: number;
  infront: boolean;
  onScreen: boolean;
}

// camera.matrixWorldInverse * world、続いて projectionMatrix を手計算で適用。
export function projectToScreen(
  camera: any, wx: number, wy: number, wz: number, viewW: number, viewH: number,
): Projected {
  const v = camera.matrixWorldInverse.elements as number[]; // view行列
  const p = camera.projectionMatrix.elements as number[];

  // view空間
  const ex = v[0] * wx + v[4] * wy + v[8] * wz + v[12];
  const ey = v[1] * wx + v[5] * wy + v[9] * wz + v[13];
  const ez = v[2] * wx + v[6] * wy + v[10] * wz + v[14];

  // clip空間
  const cx = p[0] * ex + p[4] * ey + p[8] * ez + p[12];
  const cy = p[1] * ex + p[5] * ey + p[9] * ez + p[13];
  const cw = p[3] * ex + p[7] * ey + p[11] * ez + p[15];

  const infront = cw > 0.0001;
  const ndcX = cx / cw, ndcY = cy / cw;
  return {
    x: (ndcX * 0.5 + 0.5) * viewW,
    y: (-ndcY * 0.5 + 0.5) * viewH,
    depth: -ez, // カメラからの距離（前方+）
    infront,
    onScreen: infront && ndcX >= -1.05 && ndcX <= 1.05 && ndcY >= -1.05 && ndcY <= 1.05,
  };
}
